'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactI18next = require('react-i18next');

var _OrderSummaryItemStyle = require('./OrderSummaryItemStyle.scss');

var _OrderSummaryItemStyle2 = _interopRequireDefault(_OrderSummaryItemStyle);

var _InlineColorSwatch = require('../ColorSwatch/InlineColorSwatch');

var _InlineColorSwatch2 = _interopRequireDefault(_InlineColorSwatch);

var _Price = require('../Price');

var _Price2 = _interopRequireDefault(_Price);

var _lineItem = require('../../helpers/lineItem');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderSummaryItem = (_dec = (0, _reactI18next.translate)(), _dec2 = (0, _reactCssModules2.default)(_OrderSummaryItemStyle2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(OrderSummaryItem, _React$Component);

  function OrderSummaryItem() {
    (0, _classCallCheck3.default)(this, OrderSummaryItem);
    return (0, _possibleConstructorReturn3.default)(this, (OrderSummaryItem.__proto__ || (0, _getPrototypeOf2.default)(OrderSummaryItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(OrderSummaryItem, [{
    key: 'variant',
    value: function variant() {
      return this.props.variant;
    }
  }, {
    key: 'itemClass',
    value: function itemClass() {
      if (this.props.orderCompletePage) {
        return 'summaryItem summaryItem--image';
      }

      return 'summaryItem';
    }
  }, {
    key: 'renderColorSwatch',
    value: function renderColorSwatch() {
      if (!(0, _lineItem.hasHexRef)(this.variant())) {
        return '';
      }

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_InlineColorSwatch2.default, {
          hexRef: (0, _lineItem.hexRef)(this.variant()),
          name: (0, _lineItem.colorOption)(this.variant()).presentation
        })
      );
    }
  }, {
    key: 'renderSizeAndQuantity',
    value: function renderSizeAndQuantity() {
      var t = this.props.t;


      if (!t.orderCompletePage) {
        return '';
      }

      return _react2.default.createElement(
        'span',
        { styleName: 'summaryItem__options' },
        (0, _lineItem.sizeOption)(this.variant()).presentation,
        _react2.default.createElement(
          'span',
          { styleName: 'sizeQty__separator' },
          ' | '
        ),
        t('spree.qty'),
        ': ',
        t.quantity
      );
    }
  }, {
    key: 'renderImage',
    value: function renderImage() {
      if (!this.props.orderCompletePage) {
        return '';
      }

      return _react2.default.createElement('img', {
        src: (0, _lineItem.imageUrl)(this.variant()),
        styleName: 'summaryItem__image',
        alt: this.props.variant.name
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'li',
        { styleName: this.itemClass(), className: 'clearfix' },
        this.renderImage(),
        _react2.default.createElement(
          'div',
          { styleName: 'summaryItem__name' },
          this.props.variant.name
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'm-info' },
          this.renderColorSwatch(),
          this.renderSizeAndQuantity()
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'summaryItem__price' },
          _react2.default.createElement(_Price2.default, { amount: this.props.displayAmount })
        )
      );
    }
  }]);
  return OrderSummaryItem;
}(_react2.default.Component), _class2.propTypes = {
  displayAmount: _react.PropTypes.string.isRequired,
  quantity: _react.PropTypes.number.isRequired,
  orderCompletePage: _react.PropTypes.bool,
  variant: _react.PropTypes.object.isRequired
}, _class2.defaultProps = {
  orderCompletePage: false
}, _temp)) || _class) || _class);
exports.default = OrderSummaryItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/OrderSummary/OrderSummaryItem.js
// module id = 2300
// module chunks = 0